import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Button,
  SearchField,
  BREAKPOINTS,
  COLORS
} from "@onelogin/react-components";
import SecureNotesTable from "./SecureNotesTable";
import ShowNoteScreen from "../ShowNoteScreen/ShowNoteScreen";

const SearchBarWrapper = styled.div`
  width: 33%; //this should be a same value as is the weight of first column in responsive table
  margin-top: 24px;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 90%;
    margin: 16px auto;
    order: 1; //just to make it better readable
    display: ${props => props.screen !== "notes" && "none"};
  }
`;

const NewNoteWrapper = styled.div`
  align-self: flex-end;
  display: flex;
  margin-top: -38px;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 100%;
    order: 3;
    border-top: 1px solid ${COLORS.GRAY_COLORS.GRAY_94};
    background-color: ${COLORS.GRAY_COLORS.GRAY_98};
    padding: 12px 0;
    justify-content: center;
    margin-top: 0;
    display: ${props => (props.screen !== "notes" ? "none" : "flex")};
  }
`;

const NewNoteButton = styled(Button)`
  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 90%;
  }
`;

const SplitScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 100%;
  overflow: hidden;
  flex-grow: 1;
  border: 1px solid ${COLORS.GRAY_COLORS.GRAY_94};
  margin: 12px 0px 24px 0px;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    margin: 0px;
    border: 0px;
    order: 2; //just to make it better readable
  }
`;

const SplitScreenLeftPanel = styled.div`
  background-color: white;
  width: ${props => (props.showSecureNotePanel ? "33%" : "100%")};

  @media screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}) {
    ${props => props.showSecureNotePanel && "display: none;"};
  }
`;

const SplitScreenRightPanel = styled.div`
  width: ${props => (props.showSecureNotePanel ? "67%" : "0%")};
  border-left: solid 1px ${COLORS.SEPARATOR_COLORS.LIGHT};

  @media screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}) {
    width: ${props => props.showSecureNotePanel && "100%"};
    border: 0px;
  }
`;

const SecureNotesList = ({
  userId,
  notes,
  currentNote,
  loading,
  locale,
  openNewNote,
  showSecureNote,
  onSearch,
  searchTerm,
  resetSearch,
  onClickRemove,
  showSecureNotePanel,
  screen
}) => (
  <>
    {/* <Button look="regular">
        <FormattedMessage defaultMessage="Bulk Actions" id="bulkActions" />
      </Button> */}

    <SearchBarWrapper screen={screen} data-testid="notes-search-bar">
      <SearchField
        id="search-note"
        placeholder="Search"
        onChange={event => onSearch(event.target.value)}
        value={searchTerm}
        onRemove={resetSearch}
        size="medium"
      />
    </SearchBarWrapper>
    <NewNoteWrapper screen={screen}>
      <NewNoteButton id="new-note-button" onClick={openNewNote} look="primary">
        <FormattedMessage id={"newNote"} defaultMessage="New Note" />
      </NewNoteButton>
    </NewNoteWrapper>
    <SplitScreenWrapper>
      <SplitScreenLeftPanel showSecureNotePanel={showSecureNotePanel}>
        <SecureNotesTable
          notes={notes}
          currentNote={currentNote}
          userId={userId}
          locale={locale}
          showSecureNote={showSecureNote}
          onClickRemove={onClickRemove}
          loading={loading}
          showSecureNotePanel={showSecureNotePanel}
        />
      </SplitScreenLeftPanel>
      {showSecureNotePanel && (
        <SplitScreenRightPanel showSecureNotePanel={showSecureNotePanel}>
          <ShowNoteScreen onClickRemove={onClickRemove} />
        </SplitScreenRightPanel>
      )}
    </SplitScreenWrapper>
  </>
);

SecureNotesList.propTypes = {
  userId: PropTypes.number.isRequired,
  notes: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  showSecureNote: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  resetSearch: PropTypes.func.isRequired,
  onClickRemove: PropTypes.func.isRequired,
  showSecureNotePanel: PropTypes.bool.isRequired
};

export default SecureNotesList;
